import { Button, FlexBox, Icon, IconNames, Text } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { useCallback } from 'react';

import styles from './featureCard.module.scss';

interface FeatureCardProps {
  title: string;
  description: string;
  icon: IconNames;
  learnMoreLink?: string;
}

export const FeatureCard = ({
  title,
  description,
  icon,
  learnMoreLink,
}: FeatureCardProps): JSX.Element => {
  const handleClick = useCallback(() => {
    window.open(learnMoreLink);
    ampli.agentCopilotTrialLearnMoreClicked({
      url: learnMoreLink,
    });
  }, [learnMoreLink]);
  return (
    <FlexBox
      flexDirection="column"
      justifyContent="space-between"
      gap="300"
      className={styles.featureCard}
    >
      <FlexBox flexDirection="column" gap="100">
        <FlexBox margin="0 0 100">
          <Icon name={icon} size={20} color="#5644D8" />
        </FlexBox>
        <Text.Heading variant="heading-3">{title}</Text.Heading>
        <Text.Paragraph>{description}</Text.Paragraph>
      </FlexBox>
      {learnMoreLink && (
        <FlexBox>
          <Button
            className={styles.button}
            variant="secondary"
            onClick={handleClick}
          >
            Learn more
          </Button>
        </FlexBox>
      )}
    </FlexBox>
  );
};
